module.exports = __webpack_public_path__ + "media/images/secure-66c6f17035ec8e38dfb8fe987fb32733.png";